import { User } from 'app/models/api/user';
import { BaseApiModel } from 'app/models/api/response';

export class Feedback extends BaseApiModel {
    category = '';
    description = '';
    created = '';
    user?: User;
}
